import MobileConsentSolutionsList from './MobileConsentSolutionsCreate';

export default MobileConsentSolutionsList;
